// extracted by mini-css-extract-plugin
export default {"container":"TermsConditions_container__m+yQy","termsConditionsSection":"TermsConditions_termsConditionsSection__VKJeD"};